var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6042 11.8333C13.6042 10.5102 14.6769 9.4375 16.0001 9.4375C17.3232 9.4375 18.3959 10.5102 18.3959 11.8333C18.3959 13.1565 17.3232 14.2292 16.0001 14.2292C14.6769 14.2292 13.6042 13.1565 13.6042 11.8333ZM16.0001 7.5625C13.6413 7.5625 11.7292 9.47462 11.7292 11.8333C11.7292 14.192 13.6413 16.1042 16.0001 16.1042C18.3588 16.1042 20.2709 14.192 20.2709 11.8333C20.2709 9.47462 18.3588 7.5625 16.0001 7.5625ZM12.6666 17.5625C11.5339 17.5625 10.4476 18.0125 9.64668 18.8134C8.84574 19.6143 8.39578 20.7006 8.39578 21.8333V23.5C8.39578 24.0178 8.81552 24.4375 9.33328 24.4375C9.85105 24.4375 10.2708 24.0178 10.2708 23.5V21.8333C10.2708 21.1979 10.5232 20.5885 10.9725 20.1392C11.4218 19.6899 12.0312 19.4375 12.6666 19.4375H19.3333C19.9687 19.4375 20.5781 19.6899 21.0274 20.1392C21.4767 20.5885 21.7291 21.1979 21.7291 21.8333V23.5C21.7291 24.0178 22.1488 24.4375 22.6666 24.4375C23.1844 24.4375 23.6041 24.0178 23.6041 23.5V21.8333C23.6041 20.7006 23.1542 19.6143 22.3532 18.8134C21.5523 18.0125 20.466 17.5625 19.3333 17.5625H12.6666Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.89b2ea69d75cc160f3e2baaa88f11315.svg";
export { ForwardRef as ReactComponent };